import { render, staticRenderFns } from "./Kufang.vue?vue&type=template&id=1c4203b7&scoped=true"
import script from "./Kufang.vue?vue&type=script&lang=js"
export * from "./Kufang.vue?vue&type=script&lang=js"
import style0 from "./Kufang.vue?vue&type=style&index=0&id=1c4203b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4203b7",
  null
  
)

export default component.exports